var map = {
	"./act-logo-small.png": [
		61224,
		224
	],
	"./cis-logo-small.png": [
		51121,
		121
	],
	"./dev-logo-small.png": [
		58271,
		271
	],
	"./rhenus-logo-small.png": [
		16147,
		147
	],
	"./sar-logo-small.png": [
		20097,
		478
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 91683;
module.exports = webpackAsyncContext;